export default __webpack_public_path__ + "static/project-slide-7-1248-765-bdef87d7a296982e55105d95f8be7074.jpg";